import React, { Dispatch, SetStateAction } from "react";

type Props = {
  Active: () => void;
  setCancel?: Dispatch<SetStateAction<string | undefined>>;
};

const RemovePopup = ({ Active, setCancel }: Props) => {
  return (
    <div className="remove-popup">
      <div className="title">삭제하시겠습니까?</div>
      <div className="sub">
        삭제할 경우 저장된 내용은 <br />
        복구할 수 없습니다.
      </div>
      <div className="btn-wrapper">
        <button
          className="active-btn"
          onClick={() => {
            Active();
          }}
        >
          삭제하기
        </button>
        <button
          className="deactive-btn"
          onClick={() => {
            if (setCancel) {
              setCancel(undefined);
            }
          }}
        >
          취소
        </button>
      </div>
    </div>
  );
};

export default RemovePopup;
